const API_URL = process.env.REACT_APP_URL;

export default API_URL;